import { Component, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApWindowService } from '@ap/cdk';
import { ApContentService } from '@ap/content';
import { MijnOmgevingTemplates, MijnOmgevingTemplateService, OverzichtTemplateSettings } from '@ap/mijn-template';

import { MijnOmgevingNavigation } from '../../mijn-omgeving.navigation';

import content from './mijn-context-error.content.json';
import { ErrorContext } from './mijn.context-error.model';

/**
 * @module MijnErrorModule
 * @ngdoc component
 * @name MijnContextErrorComponent
 */
@Component({
    selector: 'mijn-context-error',
    templateUrl: 'mijn-context-error.component.html',
    standalone: false
})
export class MijnContextErrorComponent implements OnInit {
    @Input()
    public errorContext: ErrorContext;

    private readonly contentService: ApContentService = inject(ApContentService);
    private readonly navigation: MijnOmgevingNavigation = inject(MijnOmgevingNavigation);
    private readonly route: ActivatedRoute = inject(ActivatedRoute);
    private readonly windowService: ApWindowService = inject(ApWindowService);
    private readonly mijnOmgevingTemplateService: MijnOmgevingTemplateService = inject(MijnOmgevingTemplateService);

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.route.data.subscribe((data) => (this.errorContext = data?.context));

        if (this.errorContext === ErrorContext.NIET_GEVONDEN) {
            // This prevents it from using the template for the original page after a redirect.
            const templateSettings: OverzichtTemplateSettings = {
                loading: false,
                title: this.contentService.get('mijn.omgeving.error.nietGevonden.pageTitle'),
                webcomponentIdentifier: 'mijn-error-pagina-niet-gevonden' as any,
                setTemplate: MijnOmgevingTemplates.EMPTY
            };
            this.mijnOmgevingTemplateService.setTemplateSettings(templateSettings);
        }
    }

    public redirect(errorContext: ErrorContext): void {
        if ([ErrorContext.BETA_UITLEG, ErrorContext.NIET_GEVONDEN].includes(errorContext)) {
            this.navigation.toHomepage();
        } else {
            const previousUrl = this.navigation.getPreviousUrl();
            this.navigation.external(this.contentService.get(`mijn.omgeving.error.${errorContext}.redirect.url`, { orgUrl: previousUrl }));
        }
    }

    public toService(errorContext: ErrorContext): void {
        this.windowService.location_href(this.contentService.get(`mijn.omgeving.error.${errorContext}.redirect.service.url`));
    }

    public hasServiceLink(errorContext: ErrorContext): boolean {
        const label = `mijn.omgeving.error.${errorContext}.redirect.service.url`;
        return this.contentService.get(label) !== label && this.contentService.get(label) !== '';
    }
}
